module.exports = __webpack_public_path__ + "img/group-title.66d331c0.png";